export const BACK_OFFICE_OPTIONS = [
  { name: "Access to reports", selected: false },
  {
    name: "Access to invoices",
    selected: false,
    // subItem: [
    //   { name: "Create New Products in a Sale", selected: false },
    //   { name: "Apply Discounts with Restricted Access", selected: false },
    // ],
  },
  { name: "Access to customers", selected: false },

  {
    name: "Access to items",
    selected: false,
    subItem: [
      { name: "Products", selected: true },
      { name: "Categories", selected: false },
      { name: "Discounts", selected: false },
    ],
  },
  {
    name: "Access to company settings",
    selected: false,
    subItem: [
      { name: "Company Information", selected: true },
      { name: "Roles", selected: false },
      { name: "Users", selected: false },
      { name: "POSs", selected: false },
      { name: "Stores", selected: false },
      { name: "Taxes", selected: false },
      { name: "Payment Channels", selected: false },
      { name: "Subscription", selected: false },
      // { name: "Log Book", selected: false },
    ],
  },
  { name: "Create Data", selected: false },
  { name: "Edit Data", selected: false },
  { name: "Delete Data", selected: false },
  { name: "Manage POS devices via email login", selected: true },
  {
    name: "Access to ZATCA Integration",
    selected: true,
    subItem: [
      {
        name: "ZATCA Integration Management",
        selected: true,
      },
    ],
  },
  // { name: "Access to live chat support", selected: false },
];

export const POS_OPTIONS = [
  {
    name: "View Invoices",
    selected: true,
    subItem: [
      { name: "Only Last 5", selected: true },
      // { name: "Only Last 20", selected: false },
      { name: "All Invoices", selected: false },
    ],
  },
  { name: "Apply discounts with restricted access", selected: false },
  { name: "Change taxes in a sale", selected: false },
  { name: "Show quick product in POS", selected: false },
  { name: "Perform refunds", selected: false },
  { name: "Reprint and resend invoices", selected: false },
  { name: "Manage items", selected: false },
  { name: "Manage settings", selected: false },
  // { name: "Access to live chat support", selected: false },
];

export const BACK_OFFICE_OPTIONS_MANAGER = [
  { name: "Access to reports", selected: true },
  { name: "Access to invoices", selected: true },
  { name: "Access to customers", selected: true },
  // {
  //   name: "Access Invoices",
  //   selected: true,
  //   subItem: [
  //     { name: "Create New Products in a Sale", selected: true },
  //     { name: "Apply Discounts with Restricted Access", selected: true },
  //   ],
  // },
  {
    name: "Access to items",
    selected: true,
    subItem: [
      { name: "Products", selected: true },
      { name: "Categories", selected: true },
      { name: "Discounts", selected: true },
    ],
  },
  {
    name: "Access to company settings",
    selected: false,
    subItem: [
      { name: "Company Information", selected: true },
      { name: "Roles", selected: false },
      { name: "Users", selected: false },
      { name: "POSs", selected: false },
      { name: "Stores", selected: false },
      { name: "Taxes", selected: false },
      { name: "Payment Channels", selected: false },
      { name: "Subscription", selected: false },
      // { name: "Log Book", selected: false },
    ],
  },
  { name: "Create Data", selected: true },
  { name: "Edit Data", selected: true },
  { name: "Delete Data", selected: true },
  { name: "Manage POS devices via email login", selected: true },
  {
    name: "Access to ZATCA Integration",
    selected: false,
    subItem: [
      {
        name: "ZATCA Integration Management",
        selected: false,
      },
    ],
  },
];

export const POS_OPTIONS_MANAGER = [
  {
    name: "View Invoices",
    selected: true,
    subItem: [
      { name: "Only Last 5", selected: false },
      // { name: "Only Last 20", selected: false },
      { name: "All Invoices", selected: true },
    ],
  },
  { name: "Apply discounts with restricted access", selected: true },
  { name: "Change taxes in a sale", selected: true },
  { name: "Show quick product in POS", selected: false },
  { name: "Perform refunds", selected: true },
  { name: "Reprint and resend invoices", selected: true },
  { name: "Manage items", selected: true },
  { name: "Manage settings", selected: true },
  // { name: "Access to live chat support", selected: false },
];
export const BACK_OFFICE_OPTIONS_CASHIER = [
  { name: "Access to reports", selected: false },
  { name: "Access to invoices", selected: true },
  { name: "Access to customers", selected: true },
  // {
  //   name: "Access Invoices",
  //   selected: true,
  //   subItem: [
  //     { name: "Create New Products in a Sale", selected: false },
  //     { name: "Apply Discounts with Restricted Access", selected: false },
  //   ],
  // },
  {
    name: "Access to items",
    selected: false,
    subItem: [
      { name: "Products", selected: false },
      { name: "Categories", selected: false },
      { name: "Discounts", selected: false },
    ],
  },
  {
    name: "Access to company settings",
    selected: false,
    subItem: [
      { name: "Company Information", selected: true },
      { name: "Roles", selected: false },
      { name: "Users", selected: false },
      { name: "POSs", selected: false },
      { name: "Stores", selected: false },
      { name: "Taxes", selected: false },
      { name: "Payment Channels", selected: false },
      { name: "Subscription", selected: false },
      // { name: "Log Book", selected: false },
    ],
  },
  { name: "Create Data", selected: true },
  { name: "Edit Data", selected: true },
  { name: "Delete Data", selected: false },
  { name: "Manage POS devices via email login", selected: true },
  {
    name: "Access to ZATCA Integration",
    selected: false,
    subItem: [
      {
        name: "ZATCA Integration Management",
        selected: false,
      },
    ],
  },
];

export const POS_OPTIONS_CASHIER = [
  {
    name: "View Invoices",
    selected: true,
    subItem: [
      { name: "Only Last 5", selected: true },
      // { name: "Only Last 20", selected: false },
      { name: "All Invoices", selected: false },
    ],
  },
  { name: "Apply discounts with restricted access", selected: false },
  { name: "Change taxes in a sale", selected: false },
  { name: "Show quick product in POS", selected: false },
  { name: "Perform refunds", selected: false },
  { name: "Reprint and resend invoices", selected: false },
  { name: "Manage items", selected: false },
  { name: "Manage settings", selected: false },
  // { name: "Access to live chat support", selected: false },
];

export const BACK_OFFICE_OPTIONS_DEFAULT = [
  { name: "Access to reports", selected: true },
  {
    name: "Access to invoices",
    selected: true,
    // subItem: [
    //   { name: "Create New Products in a Sale", selected: true },
    //   { name: "Apply Discounts with Restricted Access", selected: true },
    // ],
  },
  { name: "Access to customers", selected: true },

  {
    name: "Access to items",
    selected: true,
    subItem: [
      { name: "Products", selected: true },
      { name: "Categories", selected: true },
      { name: "Discounts", selected: true },
    ],
  },
  {
    name: "Access to company settings",
    selected: true,
    subItem: [
      { name: "Company Information", selected: true },
      { name: "Roles", selected: true },
      { name: "Users", selected: true },
      { name: "POSs", selected: true },
      { name: "Stores", selected: true },
      { name: "Taxes", selected: true },
      { name: "Payment Channels", selected: true },
      { name: "Subscription", selected: true },
      // { name: "Log Book", selected: true },
    ],
  },
  { name: "Create Data", selected: true },
  { name: "Edit Data", selected: true },
  { name: "Delete Data", selected: true },
  { name: "Manage POS devices via email login", selected: true },
  {
    name: "Access to ZATCA Integration",
    selected: true,
    subItem: [
      {
        name: "ZATCA Integration Management",
        selected: true,
      },
    ],
  },
];

export const POS_OPTIONS_DEFAULT = [
  {
    name: "View Invoices",
    selected: true,
    subItem: [
      { name: "Only Last 5", selected: false },
      // { name: "Only Last 20", selected: false },
      { name: "All Invoices", selected: true },
    ],
  },
  { name: "Apply discounts with restricted access", selected: true },
  { name: "Change taxes in a sale", selected: true },
  { name: "Show quick product in POS", selected: true },
  { name: "Perform refunds", selected: true },
  { name: "Reprint and resend invoices", selected: true },
  { name: "Manage items", selected: true },
  { name: "Manage settings", selected: true },
  // { name: "Access to live chat support", selected: true },
];

export const BACK_OFFICE_OPTIONS_NEW_ROLE = [
  { name: "Access to reports", selected: false },
  {
    name: "Access to invoices",
    selected: false,
  },
  { name: "Access to customers", selected: false },

  {
    name: "Access to items",
    selected: false,
    subItem: [
      { name: "Products", selected: true },
      { name: "Categories", selected: false },
      { name: "Discounts", selected: false },
    ],
  },
  {
    name: "Access to company settings",
    selected: false,
    subItem: [
      { name: "Company Information", selected: true },
      { name: "Roles", selected: false },
      { name: "Users", selected: false },
      { name: "POSs", selected: false },
      { name: "Stores", selected: false },
      { name: "Taxes", selected: false },
      { name: "Payment Channels", selected: false },
      { name: "Subscription", selected: false },
    ],
  },
  { name: "Create Data", selected: false },
  { name: "Edit Data", selected: false },
  { name: "Delete Data", selected: false },
  { name: "Manage POS devices via email login", selected: false },
  {
    name: "Access to ZATCA Integration",
    selected: false,
    subItem: [
      {
        name: "ZATCA Integration Management",
        selected: false,
      },
    ],
  },
];
